import React from "react";

const ProjectCard = ({ imgSrc, title, tech, demo, source, desc }) => {
  return (
    <>
      <div className="project">
        <img src={imgSrc} alt="" />
        <div>
          <h3>{title}</h3>
          <p>{desc}</p>
          <div className="tech">
            <h3>Technologies: </h3>
            {tech.map((item) => {
              return <p>{item}</p>;
            })}
          </div>
          <div className="btn-group">
            <button
              onClick={() => {
                window.open(demo);
              }}
            >
              Live Demo
            </button>
            <button
              onClick={() => {
                window.open(source);
              }}
            >
              Source Code
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectCard;
